// This component renders a switch for selecting a Till Date option in filters.
// This function is called from UserFilterCard, ChartFilterGroupCard and FilterElement.

import { alpha, FormControlLabel, FormGroup, styled, Switch, Typography } from '@mui/material';
import { datePatternCollections } from './FilterPatternCollection';

interface ISelectTillDateProps {
  isDisabled: boolean;
  shouldExclude: boolean;
  timeGrain?: string;
  isChecked: boolean;
  handleChangeTillDate: (e: any) => void;

  color?: string;
}

///Render Upto Till Date Switch
export const SelecTillDate = ({
  isDisabled,
  shouldExclude,
  timeGrain,
  isChecked,
  handleChangeTillDate,
  color,
}: ISelectTillDateProps) => {
  let labelTillDate = datePatternCollections.find((item) => item.key === timeGrain);
  let labelName = labelTillDate ? labelTillDate.value : null;
  if (labelName === 'Day Of Week') {
    labelName = 'Week';
  }
  if (timeGrain === 'hours') labelName = 'Hours';
  const tillValue = labelName === 'Hours' ? 'Now' : 'Date';

  ///Custom Green/Orange Switch
  var switchColor = '#2bb9bb';
  if (shouldExclude) {
    switchColor = '#ffb74d';
  }
  const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: switchColor,
      '&:hover': {
        backgroundColor: alpha(switchColor, theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: switchColor,
    },
  }));
  return (
    <FormGroup
      sx={{
        marginLeft: '6px',
        paddingLeft: '4px',
        paddingBottom: '8px',
      }}
    >
      {timeGrain &&
        !['yearquarter', 'yearmonth', 'date', 'dayofmonth'].includes(
          timeGrain, // Till date only available for Year, Quarter, Month, Day of Week,hours
        ) && (
          <FormControlLabel
            value="end"
            control={
              <GreenSwitch
                checked={isChecked}
                size="small"
                disabled={isDisabled}
                onChange={handleChangeTillDate}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: '13px',
                  paddingRight: '15px',
                  color: color,
                  ...(isChecked && shouldExclude ? { textDecoration: 'line-through' } : {}),
                }}
              >
                {labelName} Till {tillValue}
              </Typography>
            }
            labelPlacement="end"
          />
        )}
    </FormGroup>
  );
};
